// =============================================================================
// src/features/explore/explore-vote-roster.ts — Registro (sem deps) dos candidatos
//   sinteticos. Extraido de explore-vote-candidates p/ quebrar o ciclo: a derivacao
//   (explore-vote-data) precisa da lista de candidatos p/ montar a distribuicao por
//   regiao, e os candidatos precisam da derivacao p/ os agregados — circular. O
//   roster nao importa nada local, entao serve aos dois sem ciclo.
//
// Nomes FICTICIOS (placeholders de mockup), nao pessoas reais.
// SRP: so o registro + parsing de id. Sem DOM, sem Leaflet, sem dataset.
// =============================================================================

/** Selecao reduzida ({party,ordem}) consumida pela derivacao. */
export interface VoteCandidateSel {
  readonly party: string;
  /** Posicao do candidato dentro do partido (1 = cabeca de chapa). */
  readonly ordem: number;
}

/** Candidato sintetico: id estavel `partido#ordem`, partido, nome ficticio e ordem. */
export interface SyntheticCandidate {
  readonly id: string;
  readonly party: string;
  readonly nome: string;
  readonly ordem: number;
}

/** Separador do id (`PL#2`). */
const ID_SEP = '#';

/** Nomes FICTICIOS por partido (placeholders de mockup — nao sao pessoas reais). */
const SYNTHETIC_CANDIDATE_NAMES: Record<string, readonly string[]> = {
  Avante:       ['Marina Cordeiro', 'Tiago Bentes'],
  PL:           ['Rafael Nogueira', 'Cláudia Pinheiro', 'Otávio Lemos'],
  PSD:          ['Henrique Sales', 'Daniela Rocha'],
  MDB:          ['Eduardo Bastos', 'Lúcia Maciel'],
  PT:           ['Sérgio Andrade', 'Ana Vidal'],
  PSDB:         ['Wilson Tavares'],
  UB:           ['Alberto Farias', 'Joana Dias'],
  Republicanos: ['Silas Moura'],
  PP:           ['Átila Lima'],
  PSB:          ['Bruno Serra'],
};

/** Id estavel de um candidato por partido + ordem (`PL#1`). */
export function candidateIdOf(party: string, ordem: number): string {
  return `${party}${ID_SEP}${ordem}`;
}

/** Lista plana de todos os candidatos sinteticos (ordem = insercao, casada com PARTY_ORDER). */
export function buildSyntheticCandidates(): readonly SyntheticCandidate[] {
  const out: SyntheticCandidate[] = [];
  for (const [party, names] of Object.entries(SYNTHETIC_CANDIDATE_NAMES)) {
    names.forEach((nome, index) => {
      const ordem = index + 1;
      out.push({ id: candidateIdOf(party, ordem), party, nome, ordem });
    });
  }
  return out;
}

/** Acha um candidato pelo id (ou null). */
export function findCandidate(id: string): SyntheticCandidate | null {
  return buildSyntheticCandidates().find((c) => c.id === id) ?? null;
}

/** Selecao reduzida ({party,ordem}) de um candidato, p/ a derivacao. */
export function candidateSelOf(cand: SyntheticCandidate): VoteCandidateSel {
  return { party: cand.party, ordem: cand.ordem };
}
